import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {mergeMap} from "rxjs/operators";
import {
    USER_P_RESET,
    WorkforceOneUserLogOut
} from "../actions/WorkforceOneLoginActions";
import {EMPTY, of} from "rxjs";
import {SetSSOToken} from "../storage/AuthToken";

const WorkforceOneLogOutFromPasswordReset:  Epic<AppActions, AppActions, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(USER_P_RESET),
        mergeMap((action: AppActions) => {
                if(states$.value.Workforce1State.isLoggedIn){
                    return of (WorkforceOneUserLogOut());
                }
                SetSSOToken("");
                return EMPTY;
            }
        )
    );
};
export default WorkforceOneLogOutFromPasswordReset;
